import { useCallback, useState } from 'react'

import { Discount } from '@/types'

export const useDiscounts = () => {
    const [discountSelected, setDiscountSelected] = useState<Discount | null>(
        null
    )

    const percentageDiscount = useCallback(
        (discountType: string, optionsDiscounts: Discount[]) => {
            if (discountType === 'No aplica') {
                setDiscountSelected(null)

                return true
            }

            const discount = optionsDiscounts.find(
                (discount) => discount.categoria === discountType
            )

            if (discount) {
                // Format the percentage to a number (remove % sign and convert)
                const percentageValue =
                    parseFloat(discount.porcentaje.replace('%', '')) / 100
                const result = percentageValue > 0.25 ? false : true
                const formattedDiscount = formatCondition(discount)

                setDiscountSelected(formattedDiscount)

                return result
            }
        },
        []
    )

    const formatCondition = (discount: Discount) => {
        //if the condition is CLASE OYENTE, return CLASE_OYENTE
        if (discount.condiciones === 'CLASE OYENTE') {
            discount.condiciones = 'CLASE_OYENTE'
        }

        return discount
    }
    const noAplicaDiscount = useCallback(() => {
        return {
            clase: 'No aplica',
            categoria: 'No aplica',
            text: 'No aplica',
            partner: 'N/A',
            porcentaje: '0',
            begda: '',
            endda: '',
            condiciones: 'INACTIVAR',
            naturaleza: 'No aplica'
        }
    }, [])

    return {
        percentageDiscount,
        discountSelected,
        noAplicaDiscount,
        setDiscountSelected
    }
}
